var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2803 3.76513L5.75 13.2955L0.719666 8.26513L1.78033 7.20447L5.75 11.1741L14.2197 2.70447L15.2803 3.76513Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckS);
export default __webpack_public_path__ + "static/media/check-S.1f4de97426a8fa6a1617ff3b761a83ac.svg";
export { ForwardRef as ReactComponent };